


























































import {Component, Inject, Prop, Vue, Watch} from 'vue-property-decorator';
import FlexGridSettingsDialogColumnsList from './FlexGridDisplaySettingsEditDialogColumnsList.vue';
import {SET_EDITING_TO_SHOW_ONLY_VISIBLE_COLUMNS} from '@/store/modules/flexGridModule/flexGrid-mutation-types';

/**
 * @requires ./FlexGridDisplaySettingsEditDialogColumnsList.vue
 */
/*В связи с спецефичностью очереди событий @input библиотеки draggable пропс items модифицируется напрямую
 * https://github.com/SortableJS/Vue.Draggable/blob/master/example/components/nested-example.vue
 * */
@Component({
    components: {
        'dnd-list': FlexGridSettingsDialogColumnsList,
    },
})
export default class FlexGridSettingsEditDialogColumns extends Vue {
    @Inject() moduleName!: string;
    @Inject() commit!: Function;
    @Prop() items!: any;

    get editingToShowOnlyVisibleColumns(): boolean {
        return this.$store.state[this.moduleName].editingToShowOnlyVisibleColumns;
    }
    set editingToShowOnlyVisibleColumns(value: boolean) {
        this.commit(SET_EDITING_TO_SHOW_ONLY_VISIBLE_COLUMNS, value);
    }

    get itemsToAdd() {
        if (!this.editingToShowOnlyVisibleColumns) return [];
        else {
            let result: any[] = [];
            const callback = (item: any) => {
                if (!item.Visible && item.Key) result.push(item);
                else if (item.Columns.length > 0 && !item.Key) item.Columns.forEach(callback);
            };
            this.items.forEach(callback);
            return result;
        }
    }
}
